<template>
    <div class="app-wrapper">
      <navbar @nav-click="handleTO" />
      <app-main :current-view="currentView" />
      <copyright />
    </div>
  </template>
  
  <script>
  
  import { AppMain, Navbar, Copyright } from './components'
  import ResizeMixin from './mixin/ResizeHandler'
  import { mapState } from 'vuex'
  
  export default {
    name: 'Layout',
    components: {
      AppMain,
      Navbar,
      Copyright
    },
    mixins: [ResizeMixin],
    computed: {
      ...mapState({
        sidebar: state => state.app.sidebar,
        device: state => state.app.device,
        showSettings: state => state.settings.showSettings,
        needTagsView: state => state.settings.tagsView,
        fixedHeader: state => state.settings.fixedHeader
      })
    },
    data() {
      return {
        currentView: 'index'
      }
    },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
      },
      handleTO(e) {
        console.log(e)
        this.currentView = e
        // this.$router.push({ path: e })
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    @import "~@/styles/mixin.scss";
    @import "~@/styles/variables.scss";
  
    .app-wrapper {
      @include clearfix;
      position: relative;
      height: 100%;
      width: 100%;
  
      &.mobile.openSidebar {
        position: fixed;
        top: 0;
      }
    }
  
    .drawer-bg {
      background: #000;
      opacity: 0.3;
      width: 100%;
      top: 0;
      height: 100%;
      position: absolute;
      z-index: 999;
    }
  
    .fixed-header {
      position: fixed;
      top: 0;
      right: 0;
      z-index: 9;
      width: calc(100% - #{$sideBarWidth});
      transition: width 0.28s;
    }
  
    .hideSidebar .fixed-header {
      width: calc(100% - 54px)
    }
  
    .mobile .fixed-header {
      width: 100%;
    }
  </style>
  